import domReady from '@wordpress/dom-ready';

const headerLinks = () => {
  const gridBlock = document.querySelector('.course-grid-section');
  const perspectivesBlock = document.querySelector('h2#perspectives-davenir');
  const headerGridLink = document.querySelector('a[href="#grille-de-cours"]');
  const headersheetLink = document.querySelector('a[href="#fiche-programme"]');
  const headerPerspectivesLink = document.querySelector(
    'a[href="#perspectives-davenir"]'
  );

  if (!gridBlock) {
    if (headerGridLink) {
      headerGridLink.remove();
    }
    if (headersheetLink) {
      headersheetLink.remove();
    }
  }

  if (!perspectivesBlock) {
    if (headerPerspectivesLink) {
      headerPerspectivesLink.remove();
    }
  }
};

/////////////// ON READY /////////////////
domReady(() => {
  setTimeout(() => {
    headerLinks();
  }, 100);
});
